// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import type { SwitcherSelectionType } from 'bundles/program-home/constants/SwitcherSelectionTypes';

const ProgramSwitcherStore = createStore({
  storeName: 'ProgramSwitcherStore',

  initialize() {
    this.programSelectionType = null;
    this.programId = '';
  },

  getProgramSelectionType() {
    return this.programSelectionType;
  },
});

ProgramSwitcherStore.handlers = {
  SWITCHED_HOMEPAGE({
    selectionType,
    programId,
    degreeId,
  }: {
    selectionType: SwitcherSelectionType;
    programId?: string;
    degreeId?: string;
  }) {
    this.programSelectionType = selectionType;
    this.programId = programId;
    this.degreeId = degreeId;
  },
};

export default ProgramSwitcherStore;
